const StatsSection = () => {
  return (
    <section className="py-24 px-8">
      <div className="max-w-[1000px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 text-center">
          <div className="fade-on-scroll">
            <div className="text-5xl font-extralight text-foreground mb-3">100%</div>
            <div className="text-xs uppercase tracking-wider text-muted-foreground font-light">
              Compliance Rate
            </div>
          </div>
          <div className="fade-on-scroll" style={{ animationDelay: '0.15s' }}>
            <div className="text-5xl font-extralight text-foreground mb-3">&lt; 24hr</div>
            <div className="text-xs uppercase tracking-wider text-muted-foreground font-light">
              Deal Review
            </div>
          </div>
          <div className="fade-on-scroll" style={{ animationDelay: '0.3s' }}>
            <div className="text-5xl font-extralight text-foreground mb-3">Zero</div>
            <div className="text-xs uppercase tracking-wider text-muted-foreground font-light">
              Violations
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
